module.exports = __webpack_public_path__ + "img/sv45.69df4ae5.svg";